import { useState } from "react";
import ResourcePage from "@/components/common/ResourcePage";
import { CsvImportDialog } from "@/components/common/CsvImportDialog";
import { PageHeader } from "@/components/common/States";
import { useWorkspace } from "@/context/WorkspaceContext";
import { contacts } from "@/lib/resources";

export default function Contacts() {
  const { can } = useWorkspace();
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div data-testid="contacts-page">
      <PageHeader eyebrow="CRM" title="Contacts" description="People at your accounts — entered or imported by your team, current directors from the Companies House register, and named people found on a company's own website by Stage 1 research." />
      <ResourcePage config={contacts} reloadKey={reloadKey}
        toolbarExtra={can("write") && <CsvImportDialog entity="contacts" label="contacts" onDone={() => setReloadKey((k) => k + 1)} />} />
    </div>
  );
}
